import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { reportErrorToUser } from 'src/api/axiosClient/errorHandling';
import { useCreateQRCodeApi, useUpdateQRCodeApi } from '../api';
import {
  buildQRCodeCreateBody,
  buildQRCodeUpdateBody,
  QRCodeWriteInput,
} from '../helpers/buildQRCodeWriteBody';
import { qrCodeSaveMessage } from '../helpers/qrCodeSaveMessage';

export type QRCodeSaveInput = QRCodeWriteInput & {
  companyId: string;
  recordId: string | null;
};

export function useQRCodeSave() {
  const navigate = useNavigate();
  const createQRCodeApi = useCreateQRCodeApi();
  const updateQRCodeApi = useUpdateQRCodeApi();
  const [isSaving, setIsSaving] = useState(false);

  const save = useCallback(async ({ companyId, recordId, ...write }: QRCodeSaveInput) => {
    setIsSaving(true);
    try {
      if (recordId) {
        await updateQRCodeApi(recordId, companyId, buildQRCodeUpdateBody(write));
      } else {
        await createQRCodeApi(companyId, buildQRCodeCreateBody(write));
      }
      navigate('/qr-codes');
    } catch (error) {
      // A conflict carries no generic toast of its own, and it is the save failure the user can fix.
      reportErrorToUser(error, qrCodeSaveMessage(error, write.name));
    } finally {
      setIsSaving(false);
    }
  }, [createQRCodeApi, updateQRCodeApi, navigate]);

  return { isSaving, save };
}
